goog.provide("shadow.js.shim.module$$dnd_kit$sortable");
goog.provide("module$shadow_js_shim_module$$dnd_kit$sortable");
shadow.js.shim.module$$dnd_kit$sortable = shadow.js.nativeProvides["@dnd-kit/sortable"] = shadow$bridge("@dnd-kit/sortable");
module$shadow_js_shim_module$$dnd_kit$sortable.default = shadow.js.shim.module$$dnd_kit$sortable;
